import * as Automerge from "@automerge/automerge/slim";

/** Match Automerge's JSON representation, including Rust scalar strings. */
export function documentProjection<T>(document: T): T {
  // structuredClone discards ImmutableString.toJSON and produces { val: ... }.
  return JSON.parse(JSON.stringify(document)) as T;
}

function hasStringWrapper(value: unknown): boolean {
  if (!value || typeof value !== "object") return false;
  if (Object.keys(value).length === 1 && "val" in value && typeof value.val === "string") return true;
  return Object.values(value).some(hasStringWrapper);
}

/** Recover caches written before scalar strings were projected correctly.
 * Re-read the authoritative snapshot: a user's ordinary { val: ... } map must
 * remain a map. Do not rewrite snapshots, pending changes, or sync cursors.
 */
export function restoreStoredProjection<T extends { snapshot: Uint8Array; projection: unknown }>(entity: T): T {
  if (!hasStringWrapper(entity.projection)) return entity;
  return { ...entity, projection: documentProjection(Automerge.load(entity.snapshot)) };
}
